// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file services/webhook/api/webhook.proto (package gx.webhook.api, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_services_database_models_public } from "../../database/models/public_pb.js";
import { file_services_webhook_resources_webhook } from "../resources/webhook_pb.js";
import { file_shared_pagination } from "../../../shared/pagination_pb.js";

/**
 * Describes the file services/webhook/api/webhook.proto.
 */
export const file_services_webhook_api_webhook = /*@__PURE__*/
  fileDesc("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", [file_services_database_models_public, file_services_webhook_resources_webhook, file_shared_pagination]);

/**
 * Describes the message gx.webhook.api.CreateWebhookSourceRequest.
 * Use `create(CreateWebhookSourceRequestSchema)` to create a new message.
 */
export const CreateWebhookSourceRequestSchema = /*@__PURE__*/
  messageDesc(file_services_webhook_api_webhook, 0);

/**
 * Describes the message gx.webhook.api.CreateWebhookSourceResponse.
 * Use `create(CreateWebhookSourceResponseSchema)` to create a new message.
 */
export const CreateWebhookSourceResponseSchema = /*@__PURE__*/
  messageDesc(file_services_webhook_api_webhook, 1);

/**
 * Describes the message gx.webhook.api.GetWebhookSourceRequest.
 * Use `create(GetWebhookSourceRequestSchema)` to create a new message.
 */
export const GetWebhookSourceRequestSchema = /*@__PURE__*/
  messageDesc(file_services_webhook_api_webhook, 2);

/**
 * Describes the message gx.webhook.api.GetWebhookSourceResponse.
 * Use `create(GetWebhookSourceResponseSchema)` to create a new message.
 */
export const GetWebhookSourceResponseSchema = /*@__PURE__*/
  messageDesc(file_services_webhook_api_webhook, 3);

/**
 * Describes the message gx.webhook.api.GetWebhookSourceBySourceIdRequest.
 * Use `create(GetWebhookSourceBySourceIdRequestSchema)` to create a new message.
 */
export const GetWebhookSourceBySourceIdRequestSchema = /*@__PURE__*/
  messageDesc(file_services_webhook_api_webhook, 4);

/**
 * Describes the message gx.webhook.api.GetWebhookSourceBySourceIdResponse.
 * Use `create(GetWebhookSourceBySourceIdResponseSchema)` to create a new message.
 */
export const GetWebhookSourceBySourceIdResponseSchema = /*@__PURE__*/
  messageDesc(file_services_webhook_api_webhook, 5);

/**
 * Describes the message gx.webhook.api.ListWebhookSourcesRequest.
 * Use `create(ListWebhookSourcesRequestSchema)` to create a new message.
 */
export const ListWebhookSourcesRequestSchema = /*@__PURE__*/
  messageDesc(file_services_webhook_api_webhook, 6);

/**
 * Describes the message gx.webhook.api.ListWebhookSourcesResponse.
 * Use `create(ListWebhookSourcesResponseSchema)` to create a new message.
 */
export const ListWebhookSourcesResponseSchema = /*@__PURE__*/
  messageDesc(file_services_webhook_api_webhook, 7);

/**
 * Describes the message gx.webhook.api.UpdateWebhookSourceRequest.
 * Use `create(UpdateWebhookSourceRequestSchema)` to create a new message.
 */
export const UpdateWebhookSourceRequestSchema = /*@__PURE__*/
  messageDesc(file_services_webhook_api_webhook, 8);

/**
 * Describes the message gx.webhook.api.UpdateWebhookSourceResponse.
 * Use `create(UpdateWebhookSourceResponseSchema)` to create a new message.
 */
export const UpdateWebhookSourceResponseSchema = /*@__PURE__*/
  messageDesc(file_services_webhook_api_webhook, 9);

/**
 * Describes the message gx.webhook.api.DeleteWebhookSourceRequest.
 * Use `create(DeleteWebhookSourceRequestSchema)` to create a new message.
 */
export const DeleteWebhookSourceRequestSchema = /*@__PURE__*/
  messageDesc(file_services_webhook_api_webhook, 10);

/**
 * Describes the message gx.webhook.api.DeleteWebhookSourceResponse.
 * Use `create(DeleteWebhookSourceResponseSchema)` to create a new message.
 */
export const DeleteWebhookSourceResponseSchema = /*@__PURE__*/
  messageDesc(file_services_webhook_api_webhook, 11);

/**
 * Describes the message gx.webhook.api.RegenerateHmacKeyRequest.
 * Use `create(RegenerateHmacKeyRequestSchema)` to create a new message.
 */
export const RegenerateHmacKeyRequestSchema = /*@__PURE__*/
  messageDesc(file_services_webhook_api_webhook, 12);

/**
 * Describes the message gx.webhook.api.RegenerateHmacKeyResponse.
 * Use `create(RegenerateHmacKeyResponseSchema)` to create a new message.
 */
export const RegenerateHmacKeyResponseSchema = /*@__PURE__*/
  messageDesc(file_services_webhook_api_webhook, 13);

/**
 * Describes the message gx.webhook.api.RegenerateWebhookIdentifierRequest.
 * Use `create(RegenerateWebhookIdentifierRequestSchema)` to create a new message.
 */
export const RegenerateWebhookIdentifierRequestSchema = /*@__PURE__*/
  messageDesc(file_services_webhook_api_webhook, 14);

/**
 * Describes the message gx.webhook.api.RegenerateWebhookIdentifierResponse.
 * Use `create(RegenerateWebhookIdentifierResponseSchema)` to create a new message.
 */
export const RegenerateWebhookIdentifierResponseSchema = /*@__PURE__*/
  messageDesc(file_services_webhook_api_webhook, 15);

/**
 * @generated from service gx.webhook.api.WebhookSourceService
 */
export const WebhookSourceService = /*@__PURE__*/
  serviceDesc(file_services_webhook_api_webhook, 0);

